import axios from 'axios'

export const baseApi=axios.create({baseURL:'https://app.jalal-card.com/api/v1',withCredentials:false})